export const GET_MANAGER_REVIEWS = 'GET_MANAGER_REVIEWS';
export const GET_MANAGER_REVIEWS_SUCCESS = 'GET_MANAGER_REVIEWS_SUCCESS';
export const GET_MANAGER_REVIEWS_FAILED = 'GET_MANAGER_REVIEWS_FAILED';
